<template>
  <div>
    <el-card>
      <el-select
        class="m-w"
        v-model="StatusListValue"
        placeholder="请选择审核状态"
      >
        <el-option
          v-for="item in StatusList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>
      <el-select
        class="m-w"
        v-model="PostEnumType"
        placeholder="请选择类型筛选"
      >
        <el-option
          v-for="item in PostEnumTypeList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>
      <el-input
        style="width: 150px"
        class="m-w"
        v-model="PostName"
        placeholder="请输入岗位名称"
      ></el-input>
      <el-button type="primary" icon="el-icon-plus" @click="onClickAdd"
        >新建</el-button
      >
      <el-button type="primary" @click="GetSJEP_PostByPage">查询</el-button>

      <el-button @click="clecrData">重置</el-button>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="tui-card" v-show="isChange.length != 0">
        <div class="flex-items">
          <i class="el-icon-warning"></i>
          <div class="title">
            已选择 <span>{{ isChange.length }}</span> 项
          </div>
        </div>
        <div class="clear">清空</div>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="PostName" label="岗位名称" align="center">
        </el-table-column>
        <el-table-column
          prop="PostEnumTypeName"
          label="岗位类型"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="Phone" label="邮箱" align="center">
        </el-table-column>
        <el-table-column prop="ManageName" label="负责人名称" align="center">
        </el-table-column>
        <el-table-column prop="StatusName" label="状态" align="center">
        </el-table-column>
        <el-table-column label="简介" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.Remark"
              placement="top"
              popper-class="tool-tip"
            >
              <div class="tui-detail">{{ scope.row.Remark }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="启用禁用" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.IsOpen"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="OC_EP_PostInfo($event, scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <!-- <el-table-column label="介绍" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.Detail"
              placement="top"
              popper-class="tool-tip"
            >
              <div class="tui-detail">{{ scope.row.Detail }}</div>
            </el-tooltip>
          </template>
        </el-table-column> -->

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="onClickLook(scope.row)"
              >查看</el-button
            >
            <el-button type="text" @click="onClickEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              style="color: red"
              @click="onClickDelete(scope.row.Id)"
              >删除</el-button
            >
            <el-button
              v-if="scope.row.Status == 1"
              type="text"
              @click="onClickAudit(scope.row)"
              >去审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center; padding: 20px 0 0 0"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      :title="Title"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          label-position="top"
        >
          <el-form-item label="岗位类型" prop="postEnumType">
            <el-select
              class="m-w"
              v-model="ruleForm.postEnumType"
              placeholder="请选择岗位类型"
            >
              <el-option
                v-for="item in EnterpriseListCopy"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="岗位名称" prop="postName">
            <el-input
              v-model="ruleForm.postName"
              placeholder="请输入岗位名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="负责人名称" prop="manageName">
            <el-input
              v-model="ruleForm.manageName"
              placeholder="请输入负责人名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="介绍" prop="detail">
            <quill-editor
              v-model="ruleForm.detail"
              ref="myQuillEditor"
              class="editer"
              :options="editorOption"
            ></quill-editor>
            <el-upload
              class="avatar-uploader1"
              :file-list="[]"
              :action="uploadUrl"
              :shrow-file-list="false"
              :on-success="uploadSuccess"
            />
          </el-form-item>
          <el-form-item label="邮箱" prop="phone">
            <el-input
              v-model="ruleForm.phone"
              placeholder="请输入邮箱"
            ></el-input>
          </el-form-item>
          <el-form-item label="最大投递人数" prop="maxDeliver">
            <el-input
              v-model="ruleForm.maxDeliver"
              placeholder="0"
              type="number"
            ></el-input>
          </el-form-item>
          <el-form-item label="简介" prop="remark">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              maxlength="200"
              show-word-limit
              v-model="ruleForm.remark"
              placeholder="请输入简介"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          :loading="loading"
          type="primary"
          @click="
            Title == '新增' ? onSubmitAdd('ruleForm') : onSubmitAdd('ruleForm')
          "
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 驳回 -->
    <el-dialog title="审核" :visible.sync="dialogVisibleAudit">
      <!-- 驳回 -->
      <el-dialog
        title="驳回理由"
        :visible.sync="dialogVisibleReject"
        width="30%"
        append-to-body
      >
        <div>
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入内容"
            v-model="remark"
          >
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onClickCancle">取 消</el-button>
          <el-button
            type="primary"
            @click="ToExamineEP_PostInfo(3, auditItem.Id)"
            >确定驳回</el-button
          >
        </span>
      </el-dialog>
      <div>
        <el-descriptions direction="vertical" :column="1" border>
          <el-descriptions-item label="企业社区名称">{{
            auditItem.MaskName
          }}</el-descriptions-item>
          <el-descriptions-item label="岗位名称">{{
            auditItem.PostName
          }}</el-descriptions-item>
          <el-descriptions-item label="岗位类型">{{
            auditItem.PostEnumTypeName
          }}</el-descriptions-item>
          <el-descriptions-item label="邮箱">
            {{ auditItem.Phone }}
          </el-descriptions-item>
          <el-descriptions-item label="负责人名称">{{
            auditItem.ManageName
          }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{
            auditItem.StatusName
          }}</el-descriptions-item>
          <el-descriptions-item label="简介">{{
            auditItem.Remark
          }}</el-descriptions-item>
          <el-descriptions-item label="介绍">
            <div v-html="auditItem.Detail"></div>
          </el-descriptions-item>
        </el-descriptions>
        <!-- <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请输入内容"
          v-model="remark"
        >
        </el-input> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleReject = true">驳 回</el-button>
        <el-button type="primary" @click="ToExamineEP_PostInfo(2, auditItem.Id)"
          >通 过</el-button
        >
      </span>
    </el-dialog>
    <!-- 学生提交列表 -->
    <el-dialog
      title="投递学生列表"
      :visible.sync="dialogVisibleStudent"
      width="60%"
    >
      <el-dialog
        width="30%"
        title="新增"
        :visible.sync="innerVisible"
        append-to-body
      >
        <el-form
          :model="formData"
          :rules="rulesForm"
          ref="formData"
          class="demo-formData"
          label-position="top"
        >
          <el-form-item label="选择学生" prop="studentId">
            <el-select
              v-model="formData.studentId"
              placeholder="请选择选择学生"
              filterable
            >
              <el-option
                v-for="item in studentList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="共建单位名称" prop="maskName">
            <el-input
              v-model="formData.maskName"
              placeholder="请输入内容"
            ></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input
              v-model="formData.address"
              placeholder="请输入内容"
            ></el-input>
          </el-form-item>
          <el-form-item label="图片">
            <more-picture
              :file-src="qualificationUrls"
              @setFileId="getFileArray($event)"
            />
          </el-form-item>
          <el-form-item label="文本" prop="content">
            <el-input
              v-model="formData.content"
              placeholder="请输入内容"
              type="textarea"
              autosize
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="innerVisible = false">取 消</el-button>
          <el-button type="primary" @click="onClickStudentAdd('formData')"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="导入"
        append-to-body
        :visible.sync="dialogVisibleImport"
      >
        <el-upload
          ref="upload"
          class="image-uploader"
          :multiple="false"
          :auto-upload="true"
          list-type="excel"
          :show-file-list="true"
          :drag="true"
          action
          :limit="1"
          :on-exceed="handleExceed"
          :before-upload="beforeUpload"
          :http-request="uploadFile"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            一次只能上传一个文件，仅限excel格式，单文件不超过5MB
          </div>
        </el-upload>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleImport = false">取消</el-button>
          <el-button type="primary" @click="ImportStudent">提交</el-button>
        </div>
      </el-dialog>
      <div>
        <el-button
          type="primary"
          @click="onClickStudent"
          style="margin-bottom: 20px"
          >新增</el-button
        >
        <el-button
          type="primary"
          @click="onClickUpload"
          style="margin-bottom: 20px"
          >导入</el-button
        >
        <el-button
          type="primary"
          @click="onStudentExeal"
          style="margin-bottom: 20px"
          >模板下载</el-button
        >
        <el-table :data="tableDataStudent" border style="width: 100%">
          <el-table-column prop="Id" label="序号" width="50" align="center">
          </el-table-column>
          <el-table-column prop="StudyYearName" label="学届" align="center">
          </el-table-column>
          <el-table-column prop="GradeName" label="年级" align="center">
          </el-table-column>
          <el-table-column prop="ClassName" label="班级" align="center">
          </el-table-column>
          <el-table-column prop="StudentName" label="学生名称" align="center">
          </el-table-column>
          <el-table-column prop="PostName" label="岗位名称" align="center">
          </el-table-column>
          <el-table-column prop="FBStatusName" label="状态" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                v-if="scope.row.FBStatus == 0"
                @click="onClickStudentAudit(scope.row)"
                >审核</el-button
              >
              <el-button
                type="text"
                style="color: red"
                @click="onClickDeleteStudent(scope.row.Id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleStudent = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleStudent = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 学生驳回 -->
    <el-dialog title="审核" :visible.sync="dialogVisibleAuditStudent">
      <!-- 驳回 -->
      <el-dialog
        title="驳回理由"
        :visible.sync="dialogVisibleRejectStudent"
        width="30%"
        append-to-body
      >
        <div>
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入内容"
            v-model="remarkStudent"
          >
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onClickCancleStudent">取 消</el-button>
          <el-button
            type="primary"
            @click="SP_ForPracticeInfo(3, studentAudit.Id)"
            >确定驳回</el-button
          >
        </span>
      </el-dialog>
      <div>
        <el-descriptions direction="vertical" :column="1" border>
          <el-descriptions-item label="学届">{{
            studentAudit.StudyYearName
          }}</el-descriptions-item>
          <el-descriptions-item label="年级">{{
            studentAudit.GradeName
          }}</el-descriptions-item>
          <el-descriptions-item label="班级">{{
            studentAudit.ClassName
          }}</el-descriptions-item>
          <el-descriptions-item label="学生名称">
            {{ studentAudit.StudentName }}
          </el-descriptions-item>
          <el-descriptions-item label="岗位名称">{{
            studentAudit.PostName
          }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{
            studentAudit.FBStatusName
          }}</el-descriptions-item>
          <el-descriptions-item label="修改时间">{{
            studentAudit.UpdateTime
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleRejectStudent = true">驳 回</el-button>
        <el-button
          type="primary"
          @click="SP_ForPracticeInfo(2, studentAudit.Id)"
          >通 过</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  Get_MaskSelectInfo,
  GetSJEP_PostByPage,
  GetCheckStatusSelectInfo,
  AddEP_PostInfo,
  DeleteEP_PostInfo,
  OC_EP_PostInfo,
  ToExamineEP_PostInfo,
  GetEP_PracticeInfoByPost,
  GetStudentSelect,
  SaveEP_Stu_PracticeInfo,
  Delete_ForPracticeInfo,
  SP_ForPracticeInfo,
  ImportUploadFileExcel,
  ImportPostStudent,
} from "../../api/api";
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ align: [] }],
  ["link", "image"],
  ["clean"], // remove formatting button
];
import morePicture from "../../components/morePicture.vue";

export default {
  components: { quillEditor, morePicture },
  data() {
    return {
      tableData: [],
      isChange: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      EnterpriseList: [],
      EnterpriseListValue: "",
      StatusList: [],
      StatusListValue: "",
      PostName: "",
      Title: "",
      dialogVisible: false,
      ruleForm: {
        id: 0,
        eP_MaskId: "0",
        postName: "",
        postEnumType: "",
        manageName: "",
        detail: "",
        phone: "",
        remark: "",
        maxDeliver: "",
      },
      rules: {
        postName: [
          { required: true, message: "请输入岗位名称", trigger: "blur" },
        ],
        postEnumType: [
          { required: true, message: "请选择岗位类型", trigger: "change" },
        ],
        manageName: [
          { required: true, message: "请输入负责人名称", trigger: "blur" },
        ],
        detail: [{ required: true, message: "请输入介绍", trigger: "blur" }],
        phone: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        remark: [{ required: true, message: "请输入简介", trigger: "blur" }],
        maxDeliver: [
          { required: true, message: "请输入最大投递人数", trigger: "blur" },
        ],
      },
      loading: false,
      dialogVisibleAudit: false,
      remark: "",
      Id: 0,
      EnterpriseListCopy: [
        {
          Id: 2,
          Name: "校内实践",
        },
        {
          Id: 3,
          Name: "校外实践",
        },
      ],
      uploadUrl: "/api/Img/UploadImg",
      // 富文本编辑器配置
      editorOption: {
        placeholder: "请输入内容",
        theme: "snow", // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  // 触发input框选择图片文件
                  document.querySelector(".avatar-uploader1 input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
      auditItem: {},
      dialogVisibleReject: false,
      PostEnumTypeList: [
        {
          Id: -1,
          Name: "全部",
        },
        {
          Id: 2,
          Name: "校内实践岗位",
        },
        {
          Id: 3,
          Name: "校外实践岗位",
        },
      ],
      PostEnumType: -1,
      dialogVisibleStudent: false,
      innerVisible: false,
      studentList: [],
      formData: {
        studentId: null,
        eP_PostId: null,
        maskName: "",
        address: "",
        image: "",
        content: "",
      },
      rulesForm: {
        studentId: [
          { required: true, message: "请选择学生", trigger: "change" },
        ],
        maskName: [
          { required: true, message: "请输入共建单位名称", trigger: "blur" },
        ],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        img: [{ required: true, message: "请选择图片", trigger: "change" }],
      },
      tableDataStudent: [],
      qualificationUrls: [],
      studentAudit: {},
      dialogVisibleAuditStudent: false,
      dialogVisibleRejectStudent: false,
      remarkStudent: "",
      dialogVisibleImport: false,
      excelurl: "",
    };
  },
  async created() {
    await this.GetCheckStatusSelectInfo();
    await this.GetSJEP_PostByPage();
  },
  computed: {},
  methods: {
    onStudentExeal() {
      location.href =
        "http://qinghesuyang.oss-cn-shanghai.aliyuncs.com/NewCloud/resource/13/2023/12/28/%E5%B2%97%E4%BD%8D%E5%AF%BC%E5%85%A5%E5%AD%A6%E7%94%9F%E6%A8%A1%E7%89%88.xlsx";
    },
    //上传文件
    ImportStudent() {
      if (this.excelurl) {
        ImportPostStudent({
          fileName: this.excelurl,
          postId: this.formData.eP_PostId,
        }).then((res) => {
          if (res.data.success) {
            this.$message({
              message: "成功",
              type: "success",
            });
            //初始化数据
            this.dialogVisibleImport = false;
            this.GetEP_PracticeInfoByPost();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      } else {
        this.$message({
          message: "请选择文件",
          type: "error",
        });
      }
    },
    //导入
    uploadFile(item) {
      //    //console.log(this.comId);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      //    form.append("comId", this.comId);
      form.append("filetype", "excel");
      // //console.log(form);
      //debugger;
      ImportUploadFileExcel(form).then((res) => {
        //console.log(res, "aaaaaaaaa");
        this.excelurl = res.data.url;
        // //console.log(response);
        // //console.log(this.excelurl);
        this.$message.info("文件：" + fileObj.name + "上传成功");
      });
    },
    // 上传文件个数超过定义的数量
    handleExceed() {
      this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传`);
    },
    beforeUpload(file) {
      //console.log("beforeUpload");
      // //console.log(file.type);
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      return isText | isTextComputer;
    },
    onClickUpload() {
      this.dialogVisibleImport = true;
      this.$nextTick(() => {
        // 清空el-upload的文件列表
        this.$refs.upload.clearFiles(); //去掉文件列表
      });
    },
    onClickStudentAudit(item) {
      this.studentAudit = item;
      this.dialogVisibleAuditStudent = true;
    },
    onClickStudentAdd(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await SaveEP_Stu_PracticeInfo(this.formData);
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "提交成功！",
            });
            this.formData = {
              studentId: null,
              eP_PostId: null,
              maskName: "",
              address: "",
              image: "",
              content: "",
            };
            this.innerVisible = false;
            this.$refs[formName].clearValidate();
            this.GetEP_PracticeInfoByPost();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getFileArray(e) {
      this.formData.image = e;
    },
    async onClickStudent() {
      this.innerVisible = true;
      let res = await GetStudentSelect();
      if (res.data.success) {
        this.studentList = res.data.response;
      }
    },
    // 查看
    async onClickLook(item) {
      this.formData.eP_PostId = item.Id;
      this.GetEP_PracticeInfoByPost();
      this.dialogVisibleStudent = true;
    },
    async GetEP_PracticeInfoByPost() {
      let res = await GetEP_PracticeInfoByPost({
        EP_PostId: this.formData.eP_PostId,
      });
      if (res.data.success) {
        this.tableDataStudent = res.data.response;
      } else {
        this.tableDataStudent = [];
      }
    },
    onClickCancle() {
      this.dialogVisibleReject = false;
      this.dialogVisibleAudit = false;
      this.remark = "";
    },
    onClickCancleStudent() {
      this.dialogVisibleRejectStudent = false;
      this.dialogVisibleAuditStudent = false;
      this.remarkStudent = "";
    },
    uploadSuccess(res, file) {
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill;
      console.log(res, "res");
      // 如果上传成功
      if (res.success) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.info为服务器返回的图片地址
        quill.insertEmbed(length, "image", res.response);
        // 调整光标到最后
        quill.setSelection(length + 1);
        this.$forceUpdate();
      } else {
        this.$message.error("图片插入失败");
      }
      // loading动画消失
      this.quillUpdateImg = false;
    },
    async SP_ForPracticeInfo(status, Id) {
      let res = await SP_ForPracticeInfo({
        status: status,
        remark: this.remarkStudent,
        id: Id,
      });
      if (res.data.success) {
        this.$message({
          type: "success",
          message: status == 2 ? "审核成功" : "驳回成功",
        });
        this.GetEP_PracticeInfoByPost();
        this.dialogVisibleAuditStudent = false;
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    async ToExamineEP_PostInfo(status, Id) {
      let res = await ToExamineEP_PostInfo({
        status: status,
        remark: this.remark,
        id: Id,
      });
      if (res.data.success) {
        this.$message({
          type: "success",
          message: status == 2 ? "审核成功" : "驳回成功",
        });
        this.GetSJEP_PostByPage();
        this.dialogVisibleAudit = false;
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    async onClickAudit(item) {
      this.auditItem = item;
      // 假设富文本内容存在richText变量中
      const richText = item.Detail;
      // 使用正则表达式查找所有的图片标签，并在其上添加 style 属性
      const regExp = /<img(.*?)>/g;
      const processedText = richText.replace(regExp, (match, group) => {
        return `<img${group} style="max-width: 100%; max-height: 100%;"/>`;
      });
      this.auditItem.Detail = processedText;

      this.Id = item.Id;
      this.dialogVisibleAudit = true;
    },
    async OC_EP_PostInfo(e, item) {
      let res = await OC_EP_PostInfo({
        Id: item.Id,
        IsOpen: item.IsOpen ? 1 : 0,
      });
      this.GetSJEP_PostByPage();
    },
    onClickDeleteStudent(Id) {
      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await Delete_ForPracticeInfo({ id: Id });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.GetEP_PracticeInfoByPost();
        } else {
          this.$message({
            type: "error",
            message: "删除失败!",
          });
        }
      });
    },
    onClickDelete(Id) {
      this.$confirm("此操作将删除该岗位, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await DeleteEP_PostInfo({ id: Id });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.GetSJEP_PostByPage();
        } else {
          this.$message({
            type: "error",
            message: "删除失败!",
          });
        }
      });
    },
    handleClose() {
      this.clecrData();
      this.dialogVisible = false;
    },
    onClickEdit(item) {
      this.Title = "编辑";
      this.ruleForm = {
        id: item.Id,
        postName: item.PostName,
        postEnumType: item.PostEnumType,
        manageName: item.ManageName,
        detail: item.Detail,
        phone: item.Phone,
        remark: item.Remark,
        eP_MaskId: "0",
        maxDeliver: item.MaxDeliver,
      };
      this.dialogVisible = true;
    },
    clecrData() {
      this.ruleForm = {
        id: 0,
        eP_MaskId: "0",
        postName: "",
        postEnumType: "",
        manageName: "",
        detail: "",
        phone: "",
        remark: "",
        maxDeliver: "",
      };
      this.PostName = "";
      this.EnterpriseListValue = "";
      this.StatusListValue = 0;
      this.GetSJEP_PostByPage();
    },
    onSubmitAdd(formName) {
      this.loading = true;
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await AddEP_PostInfo(this.ruleForm);
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "成功",
            });
            this.dialogVisible = false;
            this.loading = false;
            this.$refs[formName].clearValidate();
            this.clecrData();
          } else {
            this.loading = false;

            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        } else {
          this.loading = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    onClickAdd() {
      this.Title = "新增";
      this.dialogVisible = true;
    },
    async GetSJEP_PostByPage() {
      let res = await GetSJEP_PostByPage({
        PostName: this.PostName,
        MaskId: 0,
        Status: this.StatusListValue,
        PostEnumType: this.PostEnumType,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: "",
      });
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    async GetCheckStatusSelectInfo() {
      let res = await GetCheckStatusSelectInfo();
      if (res.data.success) {
        this.StatusList = res.data.response;
        this.StatusListValue = res.data.response[0].Id;
      }
    },
    // async Get_MaskSelectInfo() {
    //   let res = await Get_MaskSelectInfo();
    //   if (res.data.success) {
    //     this.EnterpriseList = res.data.response;
    //     this.EnterpriseListCopy = res.data.response;
    //   }
    // },
    handleSelectionChange(e) {
      console.log(e);
      this.isChange = e;
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetSJEP_PostByPage();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetSJEP_PostByPage();
    },
  },
};
</script>
<style lang="less" scoped>
.m-w {
  margin-right: 10px;
}
/deep/.el-descriptions__table /deep/.is-bordered {
  table-layout: fixed;
}
.tui-detail {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/deep/.el-tooltip__popper {
  max-width: 400px;
}

.tui-card {
  width: 100%;
  height: 40px;
  background-color: rgba(230, 247, 255, 1);
  color: rgba(16, 16, 16, 1);
  border: 1px solid rgba(186, 231, 255, 1);
  margin-bottom: 10px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  i {
    color: #1890ff;
  }
  .clear {
    color: #1890ff;
  }
  .title {
    padding-left: 10px;
    color: #101010;
    font-size: 14px;
    font-weight: 600;
    span {
      color: #1890ff;
      padding: 0 5px;
    }
  }
}
</style>